import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CustomerService {
  constructor() {}

  getFormattedAddress(customer = null) {
    if (!customer) return '';

    let address = '';
    if (customer.address) address += customer.address + '\n';
    if (customer.city) address += customer.city;
    if (customer.city && customer.state) address += ', ';
    if (customer.state) address += customer.state;
    if ((customer.state && customer.zip) || (customer.city && customer.zip)) address += ', ';
    if (customer.zip) address += customer.zip;

    return address.endsWith('\n') ? address.slice(0, -1) : address;
  }
}
